/**
 * Created by laugh on 12/18/2017.
 */
import React, { Component } from 'react';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import MainHeader from '../header';
import MealtristHeader from '../Core/mealtristHeader';
import {FormGroup} from 'react-bootstrap';
import * as ReactBootstrap from 'react-bootstrap';
import '../../App.css';
import 'font-awesome/css/font-awesome.css';
import swal from 'sweetalert';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css'; // ES6
import ImageCompressor from 'image-compressor.js';
import MealtristFooter from "../Core/mealtrist-footer";

class ProfileEdit extends React.Component {
    constructor(props) {
        super(props);
        this.state = { uploadUrl: "", user: "", messageStatus: "", successMessage: "", profile: "", isAuthor: false, employment: "", city: "", mealId: "", imgFile: "", loggedIn: false, selectedState: "Choose State", favoriteDessert: "", favoriteEntree: "", dessertLink: "", entreeLink: "", ingredientAmount: "", ingredientItem: "", ingredientSpecifics: "", ingredientCategory: "Select Measurement", about: "<br></br>", mealRating: 3};
        this.createMarkup = this.createMarkup.bind(this);
        this.capitalizeWords = this.capitalizeWords.bind(this);
        this.handleAmountChange = this.handleAmountChange.bind(this);
        this.handleItemChange = this.handleItemChange.bind(this);
        this.handleSpecificsChange = this.handleSpecificsChange.bind(this);
        this.handleKeyUp = this.handleKeyUp.bind(this);
        this.onSelectedState = this.onSelectedState.bind(this);
        this.handleFavoriteEntree = this.handleFavoriteEntree.bind(this);
        this.handleEntreeLink = this.handleEntreeLink.bind(this);
        this.handleFavoriteDessert = this.handleFavoriteDessert.bind(this);
        this.handleDessertLink = this.handleDessertLink.bind(this);
        this.onSelectImage = this.onSelectImage.bind(this);
        this.handleEmployment = this.handleEmployment.bind(this);
        this.submitMeal = this.submitMeal.bind(this);
        this.handleAbout = this.handleAbout.bind(this);
        this.deleteMealSwal = this.deleteMealSwal.bind(this);
        this.deleteMeal = this.deleteMeal.bind(this);
        this.emptyCheck = this.emptyCheck.bind(this);
        this.createStateDropdown = this.createStateDropdown.bind(this);
        this.handleCity = this.handleCity.bind(this);
    }


    capitalizeWords(str)
    {
        if(typeof(str) !== "undefined") {
            return str.replace(/\w\S*/g, function(txt){return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase();});
        }
    }

    createMarkup(text) {
        return {__html: text};
    }

    deleteMealSwal(mealId) {
        swal({
            title: "Are you sure?",
            text: "Deleting the meal here will remove it permanently.",
            buttons: {
                cancel: "Cancel",
                category: {
                    text: "Delete Meal",
                    value: "meal",
                }
            },
            dangerMode: true,
            icon: "warning",
        })
            .then((value) => {
                switch (value) {
                    case "meal":
                        this.setState(prevState => ({
                            messageStatus: "loading"
                        }));
                        this.deleteMeal(mealId);
                        break;

                    default: break;
                }
            });
    }

    deleteMeal( mealId = 0)
    {
        if(mealId > 0) {
            console.log("updating category");
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    $.ajax({
                                        url: process.env.REACT_APP_API_HOST + '/' + 'api/meal/delete/' + mealId,
                                        type: 'post',
                                        async: false,
                                        'headers': {
                                            // Use access_token previously retrieved from inContact token
                                            // service.
                                            'Authorization': 'Bearer ' + user.token,
                                        },
                                        error: function (response) {
                                            //Failed response
                                            // logOrderError(visitID, 'otsError', completeOrderData, response);
                                        },
                                        success: function (response) {
                                            if (typeof(response) !== 'undefined') {
                                                globalThis.setState(prevState => ({
                                                    messageStatus: "success"
                                                }));
                                                globalThis.setState(prevState => ({
                                                    successMessage: "Your meal has been successfully depleted"
                                                }));
                                            }
                                        }
                                    });
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    onSelectImage(event) {
        event.preventDefault();
        let file = "";
        let reader = new FileReader();
        if (event.target.files) {
            file = event.target.files[0];
            let imgUrl = window.URL.createObjectURL(file);
            const imageCompressor = new ImageCompressor();
            console.log(file);
            imageCompressor.compress(file, {quality: .6})
                .then((result) => {
                    let blobName = result.name;
                    result = new File([result], blobName);
                })
                .catch((err) => {
                    // Handle the error
                });
            this.setState({imgFile: event.target.id});
            this.setState({uploadUrl: imgUrl});
        }
    }

    submitMeal() {
        this.setState(prevState => ({
            messageStatus: "loading"
        }));
        let currentImg = null;
        currentImg = document.getElementById(this.state.imgFile);
        let reader = new FileReader();
        let file = "";

        if(currentImg && currentImg.files) {
            file = currentImg.files[0];
        }
        const imageCompressor = new ImageCompressor();
        imageCompressor.compress(file, {quality: .6})
            .then((result) => {
                let blobName = result.name;
                result = new File([result], blobName);
                file = result;
            })
            .catch((err) => {
                // Handle the error
            });
        let name = this.state.name;

        var globalThis = this;
        const user = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            phoneNumber: this.state.phoneNumber,
            token: ""
        };

        let serve = false;
        if (typeof(file.type) !== 'undefined') {
            if(!!file.type.match(/image.*/)) {
                serve = true;
            }
        }
        if(typeof(file.type) === 'undefined') {
            serve = true;
        }

        if (serve) {
            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (response) {
                        if (typeof(response.message) !== 'undefined') {
                            if (response.message.indexOf('authenticated_user') > -1) {
                                if (typeof(response.data) !== 'undefined') {
                                    if (typeof(response.data.id) !== 'undefined') {
                                        let myFormData = new FormData();
                                        myFormData.append('image[]', file);
                                        myFormData.append('id', globalThis.state.mealId);
                                        myFormData.append('employment', globalThis.state.employment);
                                        myFormData.append('favoriteDessert', globalThis.state.favoriteDessert);
                                        myFormData.append('favoriteEntree', globalThis.state.favoriteEntree);
                                        myFormData.append('dessertLink', globalThis.state.dessertLink);
                                        myFormData.append('entreeLink', globalThis.state.entreeLink);
                                        myFormData.append('city', globalThis.state.city);
                                        myFormData.append('about', globalThis.state.about);
                                        myFormData.append('state', globalThis.state.selectedState);


                                        //TESTING COMPLETE ORDERS
                                        $.ajax({
                                            url: process.env.REACT_APP_API_HOST + '/' + 'api/profile/edit',
                                            type: "POST",
                                            data: myFormData,
                                            processData: false,
                                            contentType: false,
                                            'headers': {
                                                // Use access_token previously retrieved from inContact token
                                                // service.
                                                'Authorization': 'Bearer ' + user.token,
                                            },
                                            error: function (response) {
                                                //Failed response
                                                // logOrderError(visitID, 'otsError', completeOrderData, response);
                                            },
                                            success: function (response) {
                                                console.log('image response');
                                                console.log(response);
                                                globalThis.setState(prevState => ({
                                                    messageStatus: "success"
                                                }));
                                                globalThis.setState(prevState => ({
                                                    successMessage: "Your profile has been successfully updated!"
                                                }));
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    componentWillMount() {
        let mealId = Number(this.props.match.params.id);
        this.setState(prevState => ({
            mealId: mealId
        }));
        if(mealId && mealId !== '' && mealId === parseInt(mealId, 10)) {
            var globalThis = this;
            const user = {
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                email: this.state.email,
                phoneNumber: this.state.phoneNumber,
                token: ""
            };

            user.token = localStorage.getItem("mealToken");
            if (user.token != "") {
                //TESTING COMPLETE ORDERS
                $.ajax({
                    url: process.env.REACT_APP_API_HOST + '/' + 'api/auth/user',
                    type: 'get',
                    async: false,
                    'headers': {
                        // Use access_token previously retrieved from inContact token
                        // service.
                        'Authorization': 'Bearer ' + user.token,
                    },
                    error: function (response) {
                        //Failed response
                        // logOrderError(visitID, 'otsError', completeOrderData, response);
                    },
                    success: function (authResponse) {
                        if (typeof(authResponse.message) !== 'undefined') {
                            if (authResponse.message.indexOf('authenticated_user') > -1) {
                                if (typeof(authResponse.data) !== 'undefined') {
                                    if (typeof(authResponse.data.id) !== 'undefined') {
                                        globalThis.setState(prevState => ({
                                            loggedIn: 'true'
                                        }));
                                        $.ajax({
                                            url: process.env.REACT_APP_API_HOST + '/' + 'api/profile/' + mealId,
                                            type: 'post',
                                            async: false,
                                            'headers': {
                                                // Use access_token previously retrieved from inContact token
                                                // service.
                                                'Authorization': 'Bearer ' + user.token,
                                            },
                                            error: function (response) {
                                                //Failed response
                                                // logOrderError(visitID, 'otsError', completeOrderData, response);
                                            },
                                            success: function (response) {
                                                if(typeof (response) !== 'undefined') {
                                                        if(authResponse.data.id == response.profile.user_id) {
                                                            globalThis.setState(prevState => ({
                                                                isAuthor: 'true'
                                                            }));
                                                        }
                                                        if(response.profile) {
                                                            globalThis.setState(prevState => ({
                                                                profile: response.profile
                                                            }));
                                                            globalThis.setState(prevState => ({
                                                                user: response.user
                                                            }));
                                                            globalThis.setState(prevState => ({
                                                                city: response.profile.city
                                                            }));
                                                            globalThis.setState(prevState => ({
                                                                selctedState: response.profile.state
                                                            }));
                                                            globalThis.setState(prevState => ({
                                                                employment: response.profile.employment
                                                            }));
                                                            globalThis.setState(prevState => ({
                                                                favoriteEntree: response.profile.favorite_entree
                                                            }));
                                                            globalThis.setState(prevState => ({
                                                                entreeLink: response.profile.entree_link
                                                            }));
                                                            globalThis.setState(prevState => ({
                                                                about: response.profile.about
                                                            }));
                                                            globalThis.setState(prevState => ({
                                                                favoriteDessert: response.profile.favorite_dessert
                                                            }));
                                                            globalThis.setState(prevState => ({
                                                                dessertLink: response.profile.dessert_link
                                                            }));
                                                            globalThis.setState(prevState => ({
                                                                uploadUrl: response.profile.picture
                                                            }));
                                                        }
                                                }
                                            }
                                        });
                                    }
                                }
                            }
                        }
                    }
                });
            }
        }
    }

    handleEntreeLink(event) {
        this.setState({entreeLink: event.target.value});
    }

    handleFavoriteEntree(event) {
        this.setState({favoriteEntree: event.target.value});
    }

    handleDessertLink(event) {
            this.setState({dessertLink: event.target.value});
    }

    handleFavoriteDessert(event) {
            this.setState({favoriteDessert: event.target.value});
    }

    handleEmployment(event) {
            this.setState({employment: event.target.value});
    }

    handleCity(event) {
        this.setState({city: event.target.value});
    }

    handleAbout(event) {
        this.setState({about: event});
    }

    addIngredient() {
        let newIngredient = {
            amount: "",
            measurement: "",
            item: "",
            specifics: ""
        };
    }

    handleAmountChange(event) {
        let currentTarget = event.target;
        let currentId = currentTarget.getAttribute('data-id');
        let currentValue = currentTarget.value;

        var re = /[0-9.]/g;
        var myString = currentValue.match(re);
        var newString = '';
        if (myString && myString.length !== 0) {
            for(var i = 0; i < myString.length; i++) {
                newString += myString[i];
            }
            currentValue = newString;
        } else {
            currentValue = "";
        }

    }

    handleItemChange(event) {
        let currentTarget = event.target;
        let currentId = currentTarget.getAttribute('data-id');
        let currentValue = currentTarget.value;

    }

    handleSpecificsChange(event) {
        let currentTarget = event.target;
        let currentId = currentTarget.getAttribute('data-id');
        let currentValue = currentTarget.value;

    }



    handleKeyUp(e) {
        var globalThis = this;
        if (e.keyCode === 13) {
            globalThis.triggerChange();
        }
    }

    onSelectMealRating(eventKey) {
        this.setState({mealRating: eventKey });
    }

    onSelectedState(eventKey) {
        eventKey.toUpperCase();
        this.setState({selectedState: eventKey });
    }

    createStateDropdown() {
        let items = [];
        let states = ["AL","AK","AR","AZ","CA","CO","CT","DC","DE","FL","GA","HI","IA","ID","IL","IN","KS","KY","LA","MA","MD","ME","MI","MN","MO","MS","MT","NC","NE","NH","NJ","NM","NV","NY","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WI","WV","WY"];
        for (let i = 0; i <= states.length; i++) {
            items.push(<ReactBootstrap.MenuItem eventKey={states[i]} onSelect={this.onSelectedState}>{states[i]}</ReactBootstrap.MenuItem>);
        }
        return items;
    }

    emptyCheck(value) {
        if (value && value === null || value === "null" || !value) {
            return ""
        }
        return value;
    }

    //TODO set referrer url link in containers first child link
    render() {
        console.log('loggin message state');
        console.log(this.state.isAuthor);
        console.log(this.state.loggedIn);

        const header = {
            use: ""
        }
        let output = "";
        let ingredientForm = "";

        let form = "";
        if (this.state.profile !== "") {
            form = <div>
                <div className="row">
                    <h2>About</h2>
                    <br></br>
                    <ReactQuill id="profileAbout" onChange={this.handleAbout}
                                value={this.state.about}/>
                    <br></br>
                </div>
                <div className="row">
                    <ReactBootstrap.Form inline>
                        <div className="col-md-4 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                                <ReactBootstrap.FormControl type="text" value={this.state.employment}
                                                            onChange={this.handleEmployment}
                                                            placeholder="Employment"/>
                            </ReactBootstrap.FormGroup>
                        </div>

                        <div className="col-md-4 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                                <ReactBootstrap.FormControl type="text" value={this.state.city}
                                                            onChange={this.handleCity}
                                                            placeholder="City"/>
                            </ReactBootstrap.FormGroup>
                        </div>

                        <div className="col-md-4 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formHorizontalEmail">
                                <ReactBootstrap.SplitButton title={this.state.selectedState}
                                                            pullRight id="split-button-pull-right" bsSize="large">
                                    {this.createStateDropdown()}
                                </ReactBootstrap.SplitButton>
                            </ReactBootstrap.FormGroup>
                        </div>

                    </ReactBootstrap.Form>
                </div>
                <br></br>
                <h2 className="text-center">Favorite Entree</h2>
                <div className="row">
                    <ReactBootstrap.Form inline>
                        <div className="col-md-6 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formFavoriteEntree">
                                <ReactBootstrap.FormControl type="text" value={this.emptyCheck(this.state.favoriteEntree)}
                                                            onChange={this.handleFavoriteEntree}
                                                            onKeyUp={this.handleKeyUp} placeholder="Favorite Entree"/>
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-6 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formEntreeLink">
                                <ReactBootstrap.FormControl type="text" value={this.emptyCheck(this.state.entreeLink)}
                                                            onChange={this.handleEntreeLink}
                                                            onKeyUp={this.handleKeyUp} placeholder="Entree Link"/>
                            </ReactBootstrap.FormGroup>
                        </div>
                    </ReactBootstrap.Form>
                </div>
                <br></br>
                <h2 className="text-center">Favorite Dessert</h2>
                <div className="row">
                    <ReactBootstrap.Form inline>
                        <div className="col-md-6 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="forFavoriteDessert">
                                <ReactBootstrap.FormControl type="text" value={this.emptyCheck(this.state.favoriteDessert)}
                                                            onChange={this.handleFavoriteDessert}
                                                            onKeyUp={this.handleKeyUp} placeholder="Favorite Dessert"/>
                            </ReactBootstrap.FormGroup>
                        </div>
                        <div className="col-md-6 col-xs-12">
                            <ReactBootstrap.FormGroup bsSize="large" controlId="formDessertLink">
                                <ReactBootstrap.FormControl type="text"
                                                            value={this.emptyCheck(this.state.dessertLink)}
                                                            onChange={this.handleDessertLink}
                                                            onKeyUp={this.handleKeyUp} placeholder="Dessert Link"/>
                            </ReactBootstrap.FormGroup>
                        </div>
                    </ReactBootstrap.Form>
                </div>
                <br></br>
                <div className="row">
                    <div className="col-md-4 col-xs-12">
                        <ReactBootstrap.FormGroup bsSize="large" controlId="formControlsFile">
                            <ReactBootstrap.ControlLabel>File</ReactBootstrap.ControlLabel>
                            <ReactBootstrap.FormControl onChange={this.onSelectImage} type="file" accept="image/*"/>
                            <ReactBootstrap.HelpBlock>Please upload meal image here.</ReactBootstrap.HelpBlock>
                        </ReactBootstrap.FormGroup>
                    </div>
                    <div className="col-md-4 col-xs-12">
                        {this.state.uploadUrl !== "" &&
                        <img src={this.state.uploadUrl} height="85%" width="55%"/>
                        }
                    </div>
                </div>
                <div className="row">
                    <div className="col-sm-12">
                        <ReactBootstrap.ButtonToolbar>
                            <ReactBootstrap.Button bsSize="large" onClick={this.submitMeal}>Update
                                Profile</ReactBootstrap.Button>
                        </ReactBootstrap.ButtonToolbar>
                    </div>
                </div>
            </div>

        }
        if(this.state.loggedIn === 'true') {
            header.use = <MealtristHeader/>;
            output = <div>
                {header.use}
                <div className="container main-body-content">
                    {this.state.messageStatus === "loading" &&
                    <div>
                        <div className="row">
                            <br></br>
                            <br></br>
                            <br></br>
                            <div className="text-center">
                                <i className="text-center fa fa-spinner fa-pulse fa-3x fa-fw loading-logo"></i>
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.messageStatus === "success" &&
                    <div>
                        <div className="row">
                            <br></br>
                            <div className="text-center">
                                <h2 className="text-danger">{this.state.successMessage}.</h2>
                            </div>
                        </div>
                    </div>
                    }
                    {this.state.messageStatus === "" && this.state.isAuthor === 'true' &&
                        <div>
                    <div className="row">
                        <div className="col-sm-9">
                        </div>
                        <div className="col-sm-3">
                            <div className="col-sm-12">
                                <div className="col-sm-6">
                                    <Link to={'/profile/' + this.state.mealId}>
                                        <ReactBootstrap.ButtonToolbar>
                                            <ReactBootstrap.Button bsSize="small">Cancel</ReactBootstrap.Button>
                                        </ReactBootstrap.ButtonToolbar>
                                    </Link>
                                </div>
                                <div className="col-sm-6">
                                    <ReactBootstrap.ButtonToolbar>
                                        <ReactBootstrap.Button bsSize="small"
                                                               onClick={this.deleteMealSwal.bind(this, this.state.mealId)}>Delete
                                            Meal</ReactBootstrap.Button>
                                    </ReactBootstrap.ButtonToolbar>
                                </div>
                            </div>
                        </div>
                    </div>
                    < h1 className="text-center">Edit {this.state.user.username} Profile</h1>
                        <br></br>
                    {form}
                        </div>
                    }
                </div>
                <MealtristFooter/>
            </div>
        } else {
            header.use = <MainHeader/>;
            output =
                <div>
                    {header.use}
                    <div className="text-center main-body-content">
                        <i className="fa fa-spinner fa-pulse fa-3x fa-fw loading-logo"></i>
                    </div>
                    <MealtristFooter/>
                </div>
        }
        return (
                output
        );
    }
}

export default ProfileEdit;


// WEBPACK FOOTER //
// ./src/components/Mealtrist/profileEdit.js